import { PencilIcon, PlusIcon } from "@heroicons/react/24/solid";
import Emoji from "../Emoji/Emoji";
import IconButton from "../IconButton/IconButton";
import "./styles/expressionSelector.style.sass";
import ExpressionForm from "../Forms/CharacterForm/ExpressionForm";
import { useState } from "react";
import Modal from "../Modal/Modal";
import { Expression, Version } from "@src/types/global";
interface IProps {
    version: Version;
    onClick: (arg0: Expression) => void;
}
/*
 * The expression selector. If there are less than 6 expressions for a character, it will allow a user to create additional expressions
 * @param expressions {Expression | null}	  - The current array of expressions
 * @param onClick {(Expression)=> void}		  - The function to call on click. It will be called with the expression object
 */
const ExpressionSelector = ({ version, onClick }: IProps) => {
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [selectedExpression, setSelectedExpression] =
        //@ts-ignore
        useState<Expression | null>({ image: "", icon: "joy" });

    function handleSelection(exp: Expression) {
        if (selectedExpression && selectedExpression.id == exp.id) {
            setSelectedExpression({ image: "", icon: "" });
            onClick({ image: "", icon: "" });
            return;
        }
        setSelectedExpression(exp);
        onClick(exp);
    }
    return (
        <div className="expressions__selector">
            {version.expressions != null &&
                version.expressions.map((exp, index) => {
                    return (
                        <div
                            key={index}
                            className={`button__wrapper ${selectedExpression &&
                                selectedExpression.id == exp.id &&
                                "selected"
                                }`}
                        >
                            <IconButton
                                icon={<Emoji el={exp.icon} />}
                                opened={false}
                                onClick={() => handleSelection(exp)}
                                ariaLabel={`View expression ${exp.icon}`}
                            />
                            <button
                                title="Edit this expression"
                                aria-label={`Edit expression ${exp.icon}`}
                                className="edit__button"
                                onClick={() => {
                                    setSelectedExpression(exp);
                                    setIsFormOpen(true);
                                }}
                            >
                                <PencilIcon />
                            </button>
                        </div>
                    );
                })}
            {(version.expressions == null ||
                version.expressions.length < 6) && (
                    <IconButton
                        icon={<PlusIcon className="icon--xs" />}
                        opened={false}
                        onClick={() => {
                            setSelectedExpression(null);
                            setIsFormOpen(true);
                        }}
                        ariaLabel="Add an expression"
                    />
                )}
            <Modal
                closeModalFn={() => setIsFormOpen(false)}
                isOpen={isFormOpen}
            >
                <ExpressionForm
                    versionId={version.id}
                    defaultValues={selectedExpression}
                />
            </Modal>
        </div>
    );
};
export default ExpressionSelector;
